import { Link } from '@tanstack/react-router';

interface LegalBreadcrumbProps {
  /** Current-page label, e.g. "Privacy Notice". Should match the LegalDocCard title on /trust. */
  label: string;
}

/** Home / Trust & Compliance / <current page>. Left-aligned, first two are real routes. */
export function LegalBreadcrumb({ label }: LegalBreadcrumbProps) {
  return (
    <nav className="legal-breadcrumb" aria-label="Breadcrumb">
      <Link to="/">Home</Link>
      <span className="legal-breadcrumb-sep" aria-hidden>
        /
      </span>
      <Link to="/trust">Trust &amp; Compliance</Link>
      <span className="legal-breadcrumb-sep" aria-hidden>
        /
      </span>
      <span aria-current="page">{label}</span>
    </nav>
  );
}
